module.exports = __webpack_public_path__ + "static/media/wallet-connect.f06f95f1.svg";